import { useScrollReveal } from '../../hooks/useScrollReveal';
import { Link } from 'react-router-dom';

export default function AboutSection() {
  const { ref, isVisible, style } = useScrollReveal({ threshold: 0.1, distance: 36, duration: 900 });
  const { ref: refTitle, style: styleTitle } = useScrollReveal({ threshold: 0.1, distance: 30, duration: 900 });
  const { ref: refText, style: styleText } = useScrollReveal({ threshold: 0.1, distance: 36, duration: 900, delay: 150 });
  const { ref: refImages, style: styleImages } = useScrollReveal({ threshold: 0.08, distance: 48, duration: 1000, delay: 250 });

  return (
    <section className="w-full bg-brand-cream py-20 md:py-28">
      <div className="px-6 lg:px-[7%]">
        <div ref={refTitle} style={styleTitle}>
          <span className="font-sans text-brand-gray-500 text-xs tracking-[0.15em] uppercase">
            Nuestra Historia
          </span>
        </div>

        <div className="mt-10 lg:mt-20 lg:ml-auto lg:w-[65%]">
          <div ref={ref} style={style}>
            <h2 className="font-serif text-brand-black text-[clamp(2.5rem,5vw,4.5rem)] font-bold leading-[1.15]">
              De Venezuela
              <br />
              <span className="italic">a Bilbao</span>
              <br />
              y Barcelona
            </h2>

            <div ref={refText} className="mt-10 max-w-2xl space-y-6" style={styleText}>
              <p className="font-sans text-brand-gray-500 text-[17px] leading-[1.8]">
                Anthony Sánchez es un diseñador de alta costura venezolano establecido en Barcelona.
                Se formó en la escuela de alta costura de Javier Barroeta en Bilbao y perfeccionó
                su arte con maestros como Johan Luc Katt en bordado y Ángel Amor en vestuario.
              </p>
              <p className="font-sans text-brand-gray-500 text-[17px] leading-[1.8]">
                Su perfil único combina formación técnica en sectores como automoción y aeronáutica
                con una trayectoria como modelo profesional vinculado a L’Oréal París. Desde 2017,
                su atelier en Rambla de Catalunya, 85, Principal - 2, Eixample, 08008 Barcelona, es un templo de alta costura donde cada prenda
                lleva pasión, ilusión y trabajo artesanal.
              </p>
              <div className="pt-4">
                <Link 
                  to="/sobre-nosotros"
                  className="font-sans text-brand-black text-sm uppercase tracking-[0.2em] font-medium border-b border-brand-black pb-1 hover:text-brand-gray-500 hover:border-brand-gray-500 transition-all duration-300"
                >
                  Saber más
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Images */}
        <div ref={refImages} className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-[38%_62%] gap-6" style={styleImages}>
          <div className="aspect-[4/3] rounded-[28px] overflow-hidden shadow-[0_8px_32px_rgba(0,0,0,0.08)]">
            <img
              src="/assets/anthony/about-sketching.jpg"
              alt="Anthony Sánchez dibujando un boceto en su atelier"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="aspect-[16/10] rounded-[28px] overflow-hidden shadow-[0_8px_32px_rgba(0,0,0,0.08)]">
            <img
              src="/assets/anthony/about-atelier-team.jpg"
              alt="Anthony Sánchez junto a maniquíes con trajes cream en el atelier"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}